import { Component, Input, OnInit } from '@angular/core';

import { StudenteDTO } from '../../model/newModel';
import { Router } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-header-student',
  templateUrl: './header-student.component.html',
  styleUrls: ['./header-student.component.css'],
})
export class HeaderStudentComponent implements OnInit {
  @Input() studente: StudenteDTO = new StudenteDTO();
  @Input() img: any;
  showMenu = true;

  ngOnInit(): void {}

  constructor(
    private spinner: NgxSpinnerService,
    public router: Router,
    private sharedService: SharedService
  ) {}

  goToInstructorPage(idInstructor: number) {
    this.router.navigate(['/instructor'], {
      queryParams: { idInstructor: idInstructor },
    });
  }

  goToGruppoStudioPage(idGruppoStudio: number) {
    this.router.navigate(['/group'], {
      queryParams: { idGruppo: idGruppoStudio },
    });
  }

  openMenu(value: boolean) {
    this.showMenu = !this.showMenu;
  }

  downloadDoc(idDocumento: number, nomeDocumento: string) {
    this.spinner.show();
    this.sharedService.downloadDocument(idDocumento).subscribe(
      (result) => {
        const downloadURL = window.URL.createObjectURL(result);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = nomeDocumento;
        link.click();
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore downloadDocument:' + error);
      }
    );
  }
}
